
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"32","height":"32","rx":"16","fill":"#7344C0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.0007 10.6667H14.0007V10C14.0007 9.63185 13.7022 9.33337 13.334 9.33337C12.9658 9.33337 12.6673 9.63185 12.6673 10V10.6667H10.6673C9.93094 10.6667 9.33398 11.2637 9.33398 12V20.6667C9.33398 21.4031 9.93094 22 10.6673 22H21.334C22.0704 22 22.6673 21.4031 22.6673 20.6667V12C22.6673 11.2637 22.0704 10.6667 21.334 10.6667H19.334V10C19.334 9.63185 19.0355 9.33337 18.6673 9.33337C18.2991 9.33337 18.0007 9.63185 18.0007 10V10.6667ZM10.6673 12H21.334V14H10.6673V12ZM10.6673 15.3334V20.6667H21.334V15.3334H10.6673Z","fill":"white"}})])
          )
        }
      }
    